import { render, staticRenderFns } from "./RoomFooter.vue?vue&type=template&id=654dbad8&"
import script from "./RoomFooter.vue?vue&type=script&lang=js&"
export * from "./RoomFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports